module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/commutation-a226cb770a25109b260565c8756e425e.png";